import { render, staticRenderFns } from "./form-point-cell.vue?vue&type=template&id=490139fe"
import script from "./form-point-cell.vue?vue&type=script&lang=js"
export * from "./form-point-cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports